import { UntypedFormGroup } from "@angular/forms";

  export const clearErrors = function (form: UntypedFormGroup) {
    form.updateValueAndValidity();
    Object.keys(form.controls).forEach((key) => {
      form.get(key).setErrors(null);
    });
  }